const discounts = {
    "SingleDay": {
        "DiscountPercent": 0,
        "PickDropDiscountPercent": 0
    },
    "UptoThreeDays": {
        "DiscountPercent": 5,
        "PickDropDiscountPercent": 0
    },
    "UptoSixDays": {
        "DiscountPercent": 10,
        "PickDropDiscountPercent": 0
    },
    "MoreThanSixDays": {
        "DiscountPercent": 15,
        "PickDropDiscountPercent": 0
    }
}

export default discounts;
